import styled from 'styled-components'

import { RewardsCard } from '../../RewardsCard'
import { RewardsLink } from '../../RewardsLink'

export const Card = styled(RewardsCard)`
  gap: 16px;
  background: transparent;
  padding: 0;

  @media (min-width: 1024px) {
    background-color: #f3f4f5;
    padding: 24px;
  }
`

export const Link = styled(RewardsLink)`
  align-self: flex-end;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;

  @media (min-width: 1280px) {
    flex-direction: row;
  }
`
